import SubscriptionTypes from 'store/actionTypes/subscription'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  vehicle: {},
  allowedPilots: []
}

const subscription = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case SubscriptionTypes.GET_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        list: payload?.subscriptions?.items,
        pagination: payload?.subscriptions?.meta
      }

    case SubscriptionTypes.GET_SUBSCRIPTION_DETAIL_SUCCESS:
      return { ...state, current: payload?.subscription }
    case SubscriptionTypes.UPDATE_FILTER_SUBSCRIPTION_SUCCESS:
      return { ...state, filter: payload }
    case SubscriptionTypes.GET_SUBSCRIPTIONS_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicle: payload?.subscriptionVehicle || {}
      }
    case SubscriptionTypes.GET_SUBSCRIPTIONS_VEHICLE_FAILED:
      return {
        ...state,
        vehicle: {}
      }
    case SubscriptionTypes.CLEAR_FILTER_SUBSCRIPTION_SUCCESS:
      return { ...state, filter: initialData.filter }

    case SubscriptionTypes.GET_ALLOWED_PILOTS_SUCCESS:
      return {
        ...state,
        allowedPilots: payload
      }
    default:
      return state
  }
}

export default subscription
